module.exports = __webpack_public_path__ + "img/logo.a0e2a2b2.png";